exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-menu.v-menu--inline.spesa-item__menu,.v-menu.v-menu--inline.spesa-item__menu .spesa-item{width:100%}.spesa-item__menu-container .spesa-item__menu-content{padding:0}.spesa-item__menu-container .spesa-item__menu-content .v-list__tile{padding:0;height:45px}.spesa-item__menu-container .spesa-item__menu-content .v-list__tile .v-btn{height:100%;min-width:56px}.v-card--reveal{display:flex;align-items:center;bottom:0;top:0;right:0;left:0;justify-content:center;position:absolute}.v-card--reveal__bg{filter:blur(3px);-webkit-filter:blur(3px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/VerificaNoteCard.vue?vue&type=style&index=0&lang=scss&
// module id = 820
// module chunks = 0